/**
 * @license
 *-------------------------------------------------------------------------------------------
 * Copyright © 2025 Progress Software Corporation. All rights reserved.
 * Licensed under commercial license. See LICENSE.md in the package root for more information
 *-------------------------------------------------------------------------------------------
 */
const o = (...e) => Object.assign({ allowUnsort: !0, mode: "single" }, ...e);
export {
  o as normalize
};
